import React from 'react';
import { Form, Field, ErrorMessage } from 'formik';
import Select from 'react-select';

const UserForm = (props) => {
    const {
        isSubmitting,
        setFieldValue
      } = props

    const options = expandClients(props);

    console.log(props);

    return (
        <Form>
            <Field type="email" name="email" />
            <ErrorMessage name="email" component="div" />
            <ClientSelect
                value={props.initialValues.client}
                clients={options}
                onChange={setFieldValue}
            />
            <ErrorMessage name="clientId" component="div" />
            <label>
                <Field type="checkbox" name="reports" value="asr" />
                Activity Summary
            </label>
            <label>
                <Field type="checkbox" name="reports" value="ind" />
                Learner Data
            </label>
            <button type="submit" disabled={isSubmitting}>
            Submit
            </button>
        </Form>
    )
}


class ClientSelect extends React.Component {
    handleChange = value => {
        this.props.onChange('clientId', value.value);
    }

    render() {
        return (
          <div style={{ margin: '1rem 0' }}>
            <label htmlFor="clientId">select client</label>
            <Select
              id="clientId"
              name="clientId"
              options={this.props.clients}
              multi={false}
              onChange={this.handleChange}
              value={this.props.value}
            />
          </div>
        );
      }
}

export default UserForm;

function expandClients(props) {
    let mrClients = [];
    const commaRegex = /,(?!\W*Inc).?/ig
    
    props.initialValues.clients.forEach((client) => {

        const commaClients = client.split(commaRegex);
        if (commaClients.length > 1) {
            commaClients.forEach((c) => {
                mrClients.push(c.trim());
            });
        }
        else {
            mrClients.push(client.trim());
        }
    });

    mrClients = mrClients.sort(function (a, b) {
        return a.toLowerCase().localeCompare(b.toLowerCase());
    });

    const options = [...new Set(mrClients)].map((client) => {
        return { value: client, label: client };
    });

    return options;
}
